import {
  type GetTen99PolicyConfigurationResponse,
  GetTen99PolicyConfigurationResponseSchema,
} from "@clipboard-health/contract-backend-main";
import { useGetParsedQuery } from "@src/appV2/api/useGetParsedQuery";
import { environmentConfig } from "@src/appV2/environment";
import { APP_V2_APP_EVENTS } from "@src/appV2/lib";
import { type UseQueryResult } from "@tanstack/react-query";

export type Ten99PolicyConfigurationAttributes =
  GetTen99PolicyConfigurationResponse["data"]["attributes"];

export function useGetTen99PolicyConfiguration(
  workplaceId: string
): UseQueryResult<GetTen99PolicyConfigurationResponse> {
  return useGetParsedQuery({
    url: `${environmentConfig.REACT_APP_BASE_API_URL}/workplaces/${workplaceId}/1099-policy/configuration`,
    responseSchema: GetTen99PolicyConfigurationResponseSchema,
    meta: {
      logErrorMessage: APP_V2_APP_EVENTS.GET_TEN99_POLICY_CONFIGURATION_FAILURE,
      userErrorMessage: "Failed to get 1099 policy configuration",
    },
    enabled: Boolean(workplaceId),
  });
}
